import { render } from "./ElectricCarServices.vue?vue&type=template&id=8e922a02&scoped=true"
import script from "./ElectricCarServices.vue?vue&type=script&lang=js"
export * from "./ElectricCarServices.vue?vue&type=script&lang=js"

import "./ElectricCarServices.vue?vue&type=style&index=0&id=8e922a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e922a02"]])

export default __exports__